export const TEXTS = {
  ru: {
    text: 'У вас пока нет приглашенных друзей',
  },
  en: {
    text: 'You still have no invited friends',
  },
  de: {
    text: 'Sie haben noch keinen eingeladenen Freund',
  },
};
